import MDataList from './index.vue';

MDataList.install = app => {
  app.component(MDataList.name, MDataList);
};

export default MDataList;
